<div class="card" *ngIf="isBrowser && !isMobile">
  <p-menubar [model]="items">
    <ng-template pTemplate="start">
      <div
        class="flex items-center justify-center top-0 left-0 p-2 cursor-pointer relative"
      >
        <img
          (click)="navigate('/home')"
          src="../../../../../assets/coinwush.png"
          class="rounded-lg shadow-md max-w-full h-auto"
          style="height: 200px; width: 180px; object-fit: contain"
        />
      </div>
    </ng-template>

    <ng-template pTemplate="item" let-item let-root="root">
      <a
        pRipple
        class="flex gap-3 p-menuitem-link p-2"
        (click)="changeScreen(item.label)"
      >
        <span [class]="item.icon"></span>
        <span class="font-medium text-sm">{{ item.label }}</span>
        <!-- <p-badge
          *ngIf="item.badge"
          [ngClass]="{ 'ml-auto': !root, 'ml-2': root }"
          [value]="item.badge"
        />
        <span
          *ngIf="item.shortcut"
          class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
          >{{ item.shortcut }}</span
        >
        <i
          *ngIf="item.items"
          [ngClass]="[
            'pi',
            root ? 'pi-angle-down ml-2' : 'pi-angle-right ml-auto'
          ]"
        ></i> -->
      </a>
    </ng-template>
    <ng-template pTemplate="end">
      <div
        class="flex align-items-center gap-2"
        *ngIf="isBrowser && !authService.isLogin()"
      >
        <!-- <div class="search-container">
          <i
            class="pi pi-search absolute text-400"
            style="top: 8px; left: 8px"
          ></i>
          <input
            type="text"
            #parentDiv
            [(ngModel)]="searchTerm"
            (input)="filterSuggestions()"
            (focus)="showSuggestions = true"
            (blur)="hideSuggestions()"
            placeholder="Search"
            (focus)="parentDiv.classList.add('border-yellow-300')"
            (blur)="parentDiv.classList.remove('border-yellow-300')"
            class="search-input outline-none border-round-xs pl-5 text-700"
          />

          <ul
            *ngIf="showSuggestions && filteredItems.length"
            class="suggestions-list text-sm font-medium border-round-xs shadow-1"
          >
            <li
              *ngFor="let item of filteredItems"
              (mousedown)="selectItem(item)"
            >
              {{ item.s ? item.s : item.symbol }}
            </li>
          </ul>
        </div> -->
        <div
          class="px-3 py-2 text-sm cursor-pointer highlight-bg"
          pRipple
          (click)="onNavigation('/user/login')"
        >
          Login
        </div>
        <div
          class="flex py-2 px-4 text-sm cursor-pointer surface-100 mr-4"
          pRipple
          (click)="onNavigation('/user/signup')"
        >
          <div class="ml-1">Signup</div>
        </div>
      </div>
      <div
        class="flex align-items-center gap-1"
        *ngIf="isBrowser && authService.isLogin()"
      >
        <div class="flex gap-3">
          <!-- <div class="search-container header-height">
            <i
              class="pi pi-search absolute text-400"
              style="top: 8px; left: 8px"
            ></i>
            <input
              type="text"
              #parentDiv
              [(ngModel)]="searchTerm"
              (input)="filterSuggestions()"
              (focus)="showSuggestions = true"
              (blur)="hideSuggestions()"
              placeholder="Search"
              (focus)="parentDiv.classList.add('border-yellow-300')"
              (blur)="parentDiv.classList.remove('border-yellow-300')"
              class="search-input outline-none border-round-xs pl-5 text-700"
            />

            <ul
              *ngIf="showSuggestions && filteredItems.length"
              class="suggestions-list text-sm font-medium border-round-xs shadow-1"
            >
              <li
                *ngFor="let item of filteredItems"
                (mousedown)="selectItem(item)"
              >
                {{ item.s ? item.s : item.symbol }}
              </li>
            </ul>
          </div> -->
          <div
            class="px-3 text-sm cursor-pointer highlight-bg border-round-xs flex align-content-center flex-wrap header-height"
            (click)="addFunds()"
          >
            <div>Add Funds</div>
          </div>
          <div
            class="card flex justify-content-center header-height"
            *ngIf="isBrowser && authService.isLogin()"
          >
            <p-button
              (onClick)="op.toggle($event)"
              class="border-1 border-100 flex"
            >
              <div class="pi pi-arrow-right-arrow-left text-xs text-500"></div>
              <div class="mx-2 text-xs font-medium text-500">
                <div>
                  <span>Margin Mode</span>
                  <span class="ml-2 font-semibold">{{
                    selectedMarginMode == "isolate" ? "ISOLATE" : "CROSS"
                  }}</span>
                </div>
              </div>
              <div class="pi pi-chevron-down text-xs text-500"></div>
            </p-button>
            <p-overlayPanel #op>
              <div class="flex flex-column gap-4 w-14rem">
                <div class="flex justify-content-between mt-2">
                  <div class="text-xs font-medium text-500">Margin Mode</div>
                  <div class="text-sm font-medium">
                    {{ selectedMarginMode == "isolate" ? "ISOLATE" : "CROSS" }}
                  </div>
                </div>
                <div class="flex justify-content-between">
                  <div class="text-xs font-medium text-500">
                    Available Margin
                  </div>
                  <div class="text-sm font-medium">
                    {{ accountBalance | number: "1.2-2" }} USD
                  </div>
                </div>
              </div>
              <div>
                <div class="flex justify-content-end flex-wrap">
                  <div
                    class="px-3 py-2 mt-5 text-sm cursor-pointer border-orange-200 border-1 border-round-xs w-8 text-center text-orange-500"
                    (click)="showDialog()"
                  >
                    <span>Change Margin</span>
                  </div>
                </div>
              </div>
            </p-overlayPanel>
          </div>

          <div
            class="flex py-2 px-3 text-sm surface-50 mr-4 border-100 border-1 border-round-xs header-height"
          >
            <i class="pi pi-wallet"></i>
            <div class="ml-2 text-sm font-medium text-500">
              ${{ accountBalance | number: "1.2-2" }}
            </div>
          </div>
        </div>
        <p-avatar
          icon="pi pi-user"
          [style]="{
            border: '1px solid #fdecec',
            background: 'white',
            color: '#fd7d02',
          }"
          shape="circle"
          (click)="menu.toggle($event)"
          styleClass="mr-2 cursor-pointer"
        />
        <p-menu
          [model]="profileMenu"
          [popup]="true"
          #menu
          (click)="onSelectProfile(menu)"
        >
        </p-menu>

        <p-menu
          [model]="profileMenu"
          [popup]="true"
          #wallet
          (click)="onSelectProfile(menu)"
        >
          <div class="menu-btn" (click)="addFunds()">Add Funds</div>
        </p-menu>
      </div>
    </ng-template>
  </p-menubar>
</div>

<section *ngIf="isBrowser && isMobile" id="mobile">
  <div class="header flex align-items-center justify-content-between px-3 py-2">
    <!-- Left: Menu Icon -->
    <!-- <i class="pi pi-bars text-2xl cursor-pointer"></i> -->

    <!-- Center: Search Bar -->
    <div class="search-container">
      <i
        class="pi pi-search absolute text-400"
        style="top: 10px; left: 8px"
      ></i>
      <input
        type="text"
        #parentDiv
        [(ngModel)]="searchTerm"
        (input)="filterSuggestions()"
        (focus)="showSuggestions = true"
        (blur)="hideSuggestions()"
        placeholder="Search"
        (focus)="parentDiv.classList.add('border-yellow-300')"
        (blur)="parentDiv.classList.remove('border-yellow-300')"
        class="search-input outline-none border-round-xs pl-5 text-700"
      />

      <ul
        *ngIf="showSuggestions && filteredItems.length"
        class="suggestions-list text-sm font-medium border-round-xs shadow-1"
      >
        <li *ngFor="let item of filteredItems" (mousedown)="selectItem(item)">
          {{ item.s ? item.s : item.symbol }}
        </li>
      </ul>
    </div>

    <!-- Right: Icons -->
    <div
      class="flex align-items-center"
      *ngIf="isBrowser && authService.isLogin()"
    >
      <!-- <i class="pi pi-dollar text-xl cursor-pointer"></i> -->
      <i
        class="pi pi-wallet text-xl cursor-pointer text-500 mr-3"
        (click)="navigate('/user/account', 'balance')"
      ></i>
      <p-avatar
        icon="pi pi-user"
        [style]="{
          border: '1px solid #fdecec',
          background: 'white',
          color: '#fd7d02',
        }"
        shape="circle"
        (click)="navigate('/user/profile')"
      />
      <!-- <p-menu [model]="profileMenu" [popup]="true" #menu (click)="onSelectProfile(menu)">
      </p-menu> -->
    </div>
    <div class="flex" *ngIf="isBrowser && !authService.isLogin()">
      <div
        class="px-3 text-xs py-2 mr-1 font-medium"
        (click)="onNavigation('/user/login')"
      >
        Login
      </div>
      <div
        class="px-3 text-xs highlight-bg py-2 font-medium"
        (click)="onNavigation('/user/signup')"
      >
        Sign Up
      </div>
    </div>
  </div>
</section>
<p-dialog
  header="Change margin mode"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '25rem' }"
>
  <div class="flex gap-3 mt-3">
    <div
      class="border-1 px-3 py-1 cursor-pointer border-round-xs surface-100 border-200 text-xs font-medium"
      (click)="changeMarginType('isolate')"
      [ngClass]="{ 'border-orange-400': marginTypeCond == 'isolate' }"
    >
      Isolate
    </div>
    <div
      class="border-1 px-3 py-1 cursor-pointer border-round-xs surface-100 border-200 text-xs font-medium"
      (click)="changeMarginType('cross')"
      [ngClass]="{ 'border-orange-400': marginTypeCond == 'cross' }"
    >
      Cross Margin
    </div>
  </div>

  <div class="mt-4 flex flex-column gap-3">
    <div class="text-xs font-medium text-500">You have access to trade</div>
    <div class="text-sm text-800 font-medium">All instruments / pairs</div>

    <div class="text-xs font-medium text-500">Key considerations</div>
    <div class="text-sm flex flex-column gap-2 text-800 font-medium">
      <div *ngFor="let isolate of marginListArr">
        <i class="pi pi-check mr-2 text-xs text-green-500"></i>{{ isolate }}
      </div>
    </div>
    <div class="flex justify-content-end flex-wrap">
      <p-messages
        *ngIf="messages.length"
        [(value)]="messages"
        [enableService]="false"
        class="text-xs"
      />

      <div
        class="px-3 py-2 text-sm cursor-pointer highlight-bg border-round-xs w-6 mt-4 text-center"
        (click)="switchMarginMode()"
      >
        Switch Margin Mode
      </div>
    </div>
  </div>
</p-dialog>
